import { Map } from 'immutable';
import getRootState from './rootStateSelector';

export const getLastViewedProductState = (state) => {
  return getRootState(state).get('lastViewedProduct');
};

export const getLastViewedProduct = (state) => {
  const lastViewedProductState = getLastViewedProductState(state);
  if (!lastViewedProductState) {
    return null;
  }
  return Map.isMap(lastViewedProductState)
    ? lastViewedProductState.get('product')
    : lastViewedProductState.product;
};
